/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from '../utils/axios'

// 转化客户列表
export const getCustomerConversionList = function (data: {
    conversionName?: string;
    marketClueName?: string;
    weChat?: string;
    marketClueDirectorUserIdList?: string[];
    directorUserIdList?: string[];
    leaderUserIdList?: string[];
    status?: number | null;
    isSign?: number | null;
    level?: string;
    intentionality?: string;
    followAt?: string;
    createdAt?: string;
    limit: number;
    page: number;

}) { return axios.post('/customer/getCustomerConversionList', data) }

// 批量修改负责人
export const setCustomerConversionUser = function (data: { customerConversionIdList: number[]; userId: string }) {
    return axios.post('/customer/setCustomerConversionUser', data)
}

// 收到线索
export const setCustomerConversion = function (marketClueId: number) {
    return axios.get('/customer/setCustomerConversion?marketClueId=' + marketClueId)
}

// 转化客户详情
export const getCustomerConversionById = function (id: number) {
    return axios.get('/customer/getCustomerConversionById?id=' + id)
}

// 获取主管
export const getLeaderDepartmentByUserId = function (id: string) {
    return axios.get('/customer/getLeaderDepartmentByUserId?userId=' + id)
}

// 查重
export const duplicateCheck = function (data: { id: number; types: number; values: string }) {
    return axios.post('/customer/duplicateCheck', data)
}

// 编辑保存转化客户
export const setCustomerConversionById = function (data: {
    id: number;
    realName: string;
    gender?: string;
    phone?: string;
    email?: string;
    weChat?: string;
    attendSchool?: string;
    grade?: string;
    specialized?: string;
    remark?: string;
    eduTemandList?: string[];
    parentName?: string;
    parentPhone?: string;
    parentWeChat?: string;
    targetSchool?: string;
    achievement?: string;
    feedback?: string;
    overseasStudy?: string;
    activeConsultation?: string;
    informationList?: string[];
    directorUserId?: string;
    customerConversionShareList?: string[];
    // ipqSubject: string; // 2023-12-6 移除
}) { return axios.post('/customer/setCustomerConversionById', data) }

// 添加、编辑跟进记录
export const setCustomerConversionFollow = function (data: {
    id?: number;
    customerConversionId?: number;
    intentionality?: string;
    content: string;
    customerConversionFollowDataList?: { name: string; url: string }[];
    lastFollowAt?: string;
}) { return axios.post('/customer/setCustomerConversionFollow', data) }

// 获取跟进记录
export const getCustomerConversionFollowListByCustomerConversionId = function (data: { customerConversionId: number; page: number; limit: number; isMessageReview?: string  }) {
    return axios.post('/customer/getCustomerConversionFollowListByCustomerConversionId', data)
}

// 批量跟进
export const setCustomerConversionFollowByIdList = function (data: { idList: []; intentionality: string; lastFollowAt: string; content: string  }) {
    return axios.post('/customer/setCustomerConversionFollowByIdList', data)
}

/*
* 回退线索
* customerConversionId: 转化客户id
* types: 退回原因
* content: 具体原因
*/
export const setCustomerConversionBack = function (data: { customerConversionId: number; types: string; content: string }) {
    return axios.post('/customer/setCustomerConversionBack', data)
}

/*
* 撤销回退线索
* customerConversionId: 转化客户id
*/
export const setCustomerConversionBackByCustomerConversionId = function (customerConversionId: number) {
    return axios.get('/customer/setCustomerConversionBackByCustomerConversionId', { params: { customerConversionId } })
}

/*
* 转化客户数据统计列表
* timeType: 时间段的类型
*   {
        0: 本周
        1: 本月
        2: 本季度
        3: 本年
*   }
*/
export const getCustomerConversionStatisticalData = function (data: { timeStr: string }) {
    return axios.post('/customer/getCustomerConversionStatisticalData', data)
}


/*
* 转化客户表格导出
* 参数与获取转化客户列表接口一致
*/
export const customerConversionExportData = function (data: any) {
    return axios.post('/customer/customerConversionExportData', data)
}
// b客户列表
export const getBendCustomerConversionList = function (data: {
    conversionName?: string;
    marketClueName?: string;
    weChat?: string;
    marketClueDirectorUserIdList?: string[];
    directorUserIdList?: string[];
    leaderUserIdList?: string[];
    status?: number | null;
    isSign?: number | null;
    level?: string;
    intentionality?: string;
    followAt?: string;
    createdAt?: string;
    limit: number;
    page: number;

}) { return axios.post('/customer/getCustomerBusinessList', data) }
//  b客户列表-批量设置负责人
export const setbEndCustomerConversionUser = function (data: any) {
    return axios.post('/customer/setCustomerBusinessUser', data)
}
//  b客客户-新增客户
export const setCustomerBusiness = function (data: any) {
    return axios.post('/customer/setCustomerBusiness', data)
}
// b客客户-编辑保存
export const setCustomerBusinessById = function (data: any) {
    return axios.post('/customer/setCustomerBusinessById', data)
}
export const customerBusinessExportData = function (data: any) {
    return axios.post('/customer/customerBusinessExportData', data)
}
// b客客户-详情
export const getCustomerBusinessById = function (data: any) {
    return axios.get('/customer/getCustomerBusinessById', { params: { id: data } })
}
// B端客户查重
export const duplicateCheckCustomerBusiness = function (data: any) {
    return axios.post('/customer/duplicateCheckCustomerBusiness', data)
}
// B端客户跟进记录
export const getCustomerBusinessFollowListByCustomerBusinessId = function (data: any) {
    return axios.post('/customer/getCustomerBusinessFollowListByCustomerBusinessId', data)
}
// 新增/编辑保存跟进记录
export const setCustomerBusinessFollow = function (data: any) {
    return axios.post('/customer/setCustomerBusinessFollow', data)
}
//B端客户统计数据
export const getCustomerBusinessStatisticalData = function (
    data: {
        timeStr: string;
    }
) {
    return axios.post('/customer/getCustomerBusinessStatisticalData', data)
}
//模糊匹配具体来源名称
export const getMarketClueSourceList = function (data: any) {
    return axios.post('/customer/getMarketClueSourceList', data)
}

/*
* 转化客户跟进记录统计报表*/
export const getCustomerConversionFollowList = function (
    data: {
        customerConversionName: string;
        userIdList: object[];
        createdAt: string;
        intentionality: string;
        limit: string;
        page: string;
    }
) {
    return axios.post('/customer/getCustomerConversionFollowList', data)
}

/*
* 导出拜访记录统计报表*/
export const getCustomerConversionFollowListExport = function (
    data: {
        customerConversionName: string;
        userIdList: object[];
        createdAt: string;
        intentionality: string;
    }
) {
    return axios.post('/customer/getCustomerConversionFollowListExport', data)
}
/*
* 校验转化客户是否可以跟进
*/

export const checkCustomerConversionFollow = function (data: { id: string }) {
    return axios.get('/customer/checkCustomerConversionFollow', {params: data})
}


// 公海客户列表
export const getCustomerConversionPublicList = function (data: {
    conversionName?: string;
    marketClueName?: string;
    weChat?: string;
    marketClueDirectorUserIdList?: string[];
    directorUserIdList?: string[];
    leaderUserIdList?: string[];
    status?: number | null;
    isSign?: number | null;
    level?: string;
    intentionality?: string;
    followAt?: string;
    createdAt?: string;
    limit: number;
    page: number;

}) { return axios.post('/customer/getCustomerConversionPublicList', data) }


// 转化客户-调入公海
export const setCustomerConversionPublic = function (data: {
    id: string;
}) {
    return axios.post('/customer/setCustomerConversionPublic', data)
}

// 公海详情
export const getCustomerConversionPublicById = function (data: { id: number }) {
    return axios.get('/customer/getCustomerConversionPublicById', {params: data})
}

// 捞取

export const getCustomerConversion = function (data: {
    idList: [];
}) {
    return axios.post('/customer/getCustomerConversion', data)
}

// 统计数据

export const getCustomerConversionPubliceStatisticalData = function (data: { timeStr: string }) {
    return axios.get('/customer/getCustomerConversionPubliceStatisticalData', {params: data})
}

// 转销 -
export const setCustomerConversionResale = function (data: {
    id: number;
}) {
    return axios.post('/customer/setCustomerConversionResale', data)
}

// 转销 -列表
export const getCustomerConversionResaleList = function (data: {
    conversionName: string;
    marketClueName: string;
    weChat: string;
    level: string;
    followAt: string;
    attendSchool: string;
    specialized: string;
    targetSpecialized: string;
    followNum: string;
    createdAt: string;
    marketClueDirectorUserIdList: [];
    intentionalityList: [];
    gradeList: [];
    eduTemandList: [];
    marketClueSource: [];
    level2Scourse: [];
    createdUserIdList: [];
    leaderUserIdList: [];
    level2DepartmentId: number;
    directorLevel2DepartmentId: number;
    limit: number;
    page: number;
}) {
    return axios.post('/resale/getCustomerConversionResaleList', data)
}


//成交订单
export const setCustomerConversionResaleOrder = function (data: {
    id: number;
    cooperationName: string;
    cooperaitonPrice: string;
    ratio: string;
    price: string;
    directorUserId: string;
    contractUrl: string;
}) {
    return axios.post('/resale/setCustomerConversionResaleOrder', data)
}


// 公转销客户详情
export const getCustomerConversionResaleById = function (
    data: { id: string }
) {
    return axios.get('/resale/getCustomerConversionResaleById', {params: data})
}

// 订单列表

export const getCustomerConversionResaleOrderList = function (data: {
    status: string;
    cooperationName: string;
    customerConversionName: string;
    createdUserIdList: [];
    directorUserIdList: [];
    isBackMoney: string;
    limit: number;
    page: number;
}) {
    return axios.post('/resale/getCustomerConversionResaleOrderList', data)
}

// 下载合同
export const getCustomerConversionResaleOrderContractUrlById = function (
    data: { id: string }
) {
    return axios.get('/resale/getCustomerConversionResaleOrderContractUrlById', {params: data})
}

// 下载回款凭证
export const getCustomerConversionResaleOrderBackMoneyUrlById = function (
    data: { id: string }
) {
    return axios.get('/resale/getCustomerConversionResaleOrderBackMoneyUrlById', {params: data})
}

// 回款
export const setCustomerConversionResaleOrderBackMoneyUrlById = function (data: {
    id: number;
    backMoneyUrl: string;
}) {
    return axios.post('/resale/setCustomerConversionResaleOrderBackMoneyUrlById', data)
}

// 转销回款详情
export const getCustomerConversionResaleOrderById = function (
    data: { id: string }
) {
    return axios.get('/resale/getCustomerConversionResaleOrderById', {params: data})
}

// 转销订单编辑
export const setCustomerConversionResaleOrderById = function (data: {
    id: string; // 转销订单id
    cooperationName: string; // 合作方
    cooperaitonPrice: string; // 合作方价格
    ratio: string; // 返佣比例
    price: string; // 佣金
    directorUserId: string; // 负责人id
    contractUrl: string; // 转销合同url
    backMoneyUrl: string; // 转销合同url
}) {
    return axios.post('/resale/setCustomerConversionResaleOrderById', data)
}


/*
* 转销-开票新建
* */
export const setCustomerConversionResaleInvoice = function (data: {
    customerConversionResaleOrderId: string;
    companyName: string;
    price: string;
    titleTypes: string;
    types: string;
    title: string;
    content: string;
    code: string;
    email: string;
    bank?: string;
    account?: string;
    address?: string;
    phone?: string;
}) {
    return axios.post('/resale/setCustomerConversionResaleInvoice', data)
}

/*
* 转销开票-列表
* */
export const getCustomerConversionResaleInvoiceList = function (data: {
    customerConversionResaleOrderId: string;
}) {
    return axios.get('/resale/getCustomerConversionResaleInvoiceList', {params: data})
}
